export interface IWeeklyOperatingHours<T> {
  sunday: T;
  monday: T;
  tuesday: T;
  wednesday: T;
  thursday: T;
  friday: T;
  saturday: T;
}

export const CDaysWeekList = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export interface IProductStockPeriod {
  stockPeriodId: number;
  name: string;
  description: string;
  days: IStockPeriodDay[];
  venueId: number;
}

export interface IStockPeriodDay {
  closed: boolean;
  timeRanges: ITimeRange[];
}

export interface ITimeRange {
  startTime: number;
  endTime: number;
}

export interface IMenuStockPeriod extends Omit<IProductStockPeriod, 'days'> {
  days: IWeeklyOperatingHours<IStockPeriodDay>;
}
